import { Box, Typography } from "@mui/material";
import { getStateLabel } from "components/ui/StateSelect";
import { useReportSettings } from "./ReportSettingsContext";
import { useStateTaxRate } from "hooks/useStateTaxRate";

/**
 * The state tax the strategy report levies — read-only. It is the selected
 * client's State (set on the client's Details tab) at that state's rate from
 * the Management page, so there is nothing to choose here.
 */
const StrategyTaxStateSetting = () => {
  const { settingsInfo } = useReportSettings();
  const clientId = settingsInfo.client_id ?? null;
  const { clientState, stateTaxRate, isLoading } = useStateTaxRate(clientId);

  const describe = () => {
    if (!clientId) return "Select a client to see its state tax.";
    if (isLoading) return "Loading…";
    if (!clientState) {
      return "No state set — set it on the client's Details tab.";
    }
    const rate =
      stateTaxRate == null
        ? "no tax rate set on the Management page"
        : `${stateTaxRate}%`;
    return `${getStateLabel(clientState)} — ${rate}`;
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        State tax for strategy report
      </Typography>
      <Typography variant="body2" data-testid="strategy-state-tax">
        {describe()}
      </Typography>
    </Box>
  );
};

export default StrategyTaxStateSetting;
